export const ASIGNAR_RUTA_INICIAL = "ASIGNAR_RUTA_INICIAL"